import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { css } from "styled-components";


cardContainerMultiColumnStyles.cardDivider = {
    css: css`
            padding: 15px;
            height: 100%;
            width: 100%;
            overflow: hidden;
            border: none;
        `,
};
